import axiosInstance from "@/services/http/axios-instance";

export class OrderApi {
  getOrders(params = {}) {
    return axiosInstance.get("/order", {
      params,
    });
  }

  createOrder(clientId, locale = "uk", tokenId = null, pan = null) {
    return axiosInstance.post("/order/create", {
      client_id: clientId,
      token_id: tokenId,
      pan: pan,
      locale: locale,
    });
  }

  getOrderStatus(orderId) {
    return axiosInstance.get(`/order/${orderId}/status`);
  }

  loadReceipt(orderItemId, receiptType) {
    return axiosInstance.get(`/order/item/${orderItemId}/receipt`, {
      params: {
        receipt_type: receiptType,
      },
      responseType: "blob",
    });
  }

  loadOrderPDFReceipt(orderId, receiptType) {
    return axiosInstance.get(`/order/${orderId}/receipt`, {
      params: {
        receipt_type: receiptType,
      },
      responseType: "blob",
    });
  }

  loadOrderReceipt(orderId) {
    return axiosInstance.get(`/order/${orderId}/receipts`, {
      responseType: "blob",
    });
  }

  loadOrder(orderId, updateStatus = 0) {
    return axiosInstance.get(`/order/${orderId}`, {
      params: {
        update_status: updateStatus,
      },
    });
  }

  updateOrderWidgetLink(orderId) {
    return axiosInstance.get(`/order/${orderId}/update/pay-link`);
  }

  loadOrderItemRepeatData(orderItemId) {
    return axiosInstance.get(`/order/item/${orderItemId}/repeat`);
  }

  getTokensByPhone() {
    return axiosInstance.get(`/order/token/get-all-tokens-by-phone`);
  }
}
